import useTrashRepo from '@/composables/trash/trash-repo';
import { computed } from 'vue';

export default function useTrash({ model, searchTerm, itemsPerPage }) {
  const repo = useTrashRepo(model);

  const modelTrash = computed(() => model.value);
  const searchTermTrash = computed(() => searchTerm.value);
  const itemsPerPageTrash = computed(() => itemsPerPage.value);
  const loadMore = () => {
    const page = repo.getNextPage(modelTrash.value, itemsPerPageTrash.value);
    return repo.getSoftDeleted({ page, itemsPerPage: itemsPerPageTrash.value, searchTerm: searchTermTrash.value });
  };

  const hasMore = () => repo.hasMore(modelTrash.value);

  const cleanCache = () => {
    repo.cleanCacheForModel(modelTrash.value);
  };

  const deleteSingleSoftDeleted = (uid) => repo.deleteSingleSoftDeleted(uid, model.value);
  const deleteMultipleSoftDeleted = (uids) => repo.deleteMultipleSoftDeleted(uids, model.value);
  const restoreSingleSoftDeleted = (uid) => repo.restoreSingleSoftDeleted(uid, model.value);
  const restoreMultipleSoftDeleted = (uids) => repo.restoreMultipleSoftDeleted(uids, model.value);

  return {
    cleanCache,
    trashItems: repo.trashItems,
    loadMore,
    hasMore,
    getSoftDeletedLoading: repo.getSoftDeletedLoading,

    deleteSingleSoftDeleted,
    deleteMultipleSoftDeleted,
    restoreSingleSoftDeleted,
    restoreMultipleSoftDeleted,

    subscribe: repo.subscribe,
  };
}
